import { useEffect, useState } from "react";
import { parseRssFeed } from "../services/rss/parsing.service";
import { RssItem } from "../types/rssTypes";
import { API_URLS } from "shared/config/api/urlsConfig";
import { captureSentryException } from "shared/services/sentry/captureException";

export const useRssFeed = () => {
  const [data, setData] = useState<RssItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchRss = async () => {
      try {
        const response = await fetch(API_URLS.rssFeed);

        if (!response.ok) {
          throw new Error(`Failed to fetch RSS feed: ${response.status}`);
        }

        const xmlString = await response.text();

        console.log("[xmlString]: ", xmlString);

        const parsedFeed = await parseRssFeed(xmlString);

        setData(parsedFeed);
      } catch (err) {
        captureSentryException(err, {
          tags: {
            feature: "rss",
            operation: "useRssFeed",
          },
          contexts: {
            request: {
              url: API_URLS.rssFeed,
            },
          },
        });
        console.error("Erro ao processar RSS:", err);
        setError(err instanceof Error ? err : new Error("Unexpected error"));
      } finally {
        setLoading(false);
      }
    };

    fetchRss();
  }, []);

  return { data, loading, error };
};
